import { IPosition } from '../member/member.types';

export enum EMatrixType {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  MATRIX = 'matrix',
}

export type TMatrixDimension = 1 | 2;

export interface IMatrix {
  type: EMatrixType;
  viewer: IPosition;
  viewee: IPosition;
  translationKeys: string[];
  left_label_key?: string;
  right_label_key?: string;
  bottom_label_key?: string;
  top_label_key?: string;
  left_bottom_label_key?: string;
  left_top_label_key?: string;
  right_bottom_label_key?: string;
  right_top_label_key?: string;
}

export interface IGraph {
  id: string;
  analysis?: string[];
  matrices: IMatrix[];
}

export interface ICompatibilityReport {
  analysis?: string[];
  graphes: IGraph[];
}
